import styled, { css } from 'styled-components'
import { ControlSize } from 'types'
import { RangeSliderWithoutContext } from 'ui/src/components/controls/range-slider'
import { borderRadiusFromControlSize, fontSizeFromControlSize, heightFromControlSize } from 'utils'
import StripComponent from './strip'

export const Container = styled.div<{ backgroundColor: string; controlSize: ControlSize; disabled: boolean }>`
    position: relative;
    user-select: none;
    width: 100%;

    ${({ backgroundColor, controlSize }) => css`
        background: ${backgroundColor};
        border-radius: ${borderRadiusFromControlSize(controlSize)}px;
        font-size: ${fontSizeFromControlSize(controlSize)}px;
        height: ${heightFromControlSize(controlSize)}px;
    `}

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}
`

export const Strip = styled(StripComponent)`
    height: 100%;
    width: 100%;
`

export const RangeSlider = styled(RangeSliderWithoutContext)<{ color: string; size: ControlSize }>`
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;

    ${({ color, size }) => css`
        > div {
            background: transparent !important;

            > div[role='button']:nth-child(1) {
                background: ${color};
                border-bottom-left-radius: inherit;
                border-top-left-radius: inherit;
            }

            > div[role='button']:nth-child(2) {
                border-bottom: ${borderRadiusFromControlSize(size)}px solid ${color};
                border-top: ${borderRadiusFromControlSize(size)}px solid ${color};
                box-sizing: border-box;
                position: relative;

                &:after {
                    border-radius: ${Math.ceil(borderRadiusFromControlSize(size) / 2)}px;
                    box-shadow: 0 0 0 ${borderRadiusFromControlSize(size)}px ${color};
                    content: '';
                    display: block;
                    height: 100%;
                    left: 0;
                    pointer-events: none;
                    position: absolute;
                    top: 0;
                    width: 100%;
                }
            }

            > div[role='button']:nth-child(3) {
                background: ${color};
                border-bottom-right-radius: inherit;
                border-top-right-radius: inherit;
            }
        }
    `}
`
